module.exports = __webpack_public_path__ + "img/amara-white-logo.4738f1ae.png";